import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './translations/es';

// TODO Add files of lenguages
const resources = {
  es
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
